export default __webpack_public_path__ + "static/media/gateway.3b244183.png";